import type { Client } from 'c-sdk';
import { baseInitialState, createBaseSlice } from 'c-data';
import type { ClientState } from './Client-types';

const initialState: ClientState = { ...baseInitialState };

const additionalReducers = {
    // example: (state: ClientState, action: PayloadAction<string>): ClientState => state,
};

const slice = createBaseSlice<Client, ClientState, typeof additionalReducers>({
    name: 'client',
    entityName: 'Client',
    initialState,
    reducers: additionalReducers,
});

const clientSlice = {
    clientActions: slice.slice.actions,
    clientReducer: slice.slice.reducer,
    clientAdapter: slice.adapter,
    clientSelectors: slice.selectors,
    clientThunks: slice.thunks,
};

export const { clientReducer, clientActions, clientAdapter, clientSelectors, clientThunks } =
    clientSlice;
